import {Loader2} from "lucide-react";
import {useTranslation} from "react-i18next";

import {cn} from "@/lib/utils";

type ListInfiniteLoadMoreProps = {
  className?: string;
};

/** Spinner + label for infinite-scroll fetch-next-page. Uses common.loading (no loading_more key yet). */
export function ListInfiniteLoadMore({className}: ListInfiniteLoadMoreProps) {
  const {t} = useTranslation("common");

  return (
    <div className={cn("flex flex-col items-center gap-2", className)}>
      <Loader2 className="size-4 animate-spin text-muted-foreground" />
      <span className="text-sm text-muted-foreground">{t("loading")}</span>
    </div>
  );
}
